import { Injectable } from '@angular/core';
import { GanttConfigService, GanttGlobalConfig, GanttI18nLocale } from '@worktile/gantt';
import dayjs from 'dayjs';
import 'dayjs/locale/en';

@Injectable()
export class CustomGanttConfigService extends GanttConfigService {
  constructor() {
    dayjs.locale('en');

    // ngx-gantt only recognises its own locale ids; unknown ids silently fall back to zh-hans.
    const customConfig: GanttGlobalConfig = {
      locale: GanttI18nLocale.enUs,
    };

    super(customConfig);
  }
}
